import script from "./OliviaAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./OliviaAvatar.vue?vue&type=script&setup=true&lang=js"

import "./OliviaAvatar.vue?vue&type=style&index=0&id=a7dad184&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7dad184"]])

export default __exports__